export const alertsKeys = {
  all: ['all'],
  lists: () => [...alertsKeys.all, 'list'],
  list: (page: number, perPage: number) => [...alertsKeys.lists(), { page, perPage }],
};
